module.exports = __webpack_public_path__ + "media/images/lp/1/voice3-open-21afff20ab423bfaf4ec10267afdcb19.png";